import {Directive, EventEmitter, Input, Output} from '@angular/core';
import {SubsidyWizardAction} from '../models/subsidy-wizard-action.model';
import {Subsidy} from '../models/subsidy.model';
import {FormComponent} from '../core/base/form.component';
import {ToastService} from '../core/services/toast/toast.service';
import {StepContainerAction} from '../components/step-container/step-container-action.enum';

@Directive()
export abstract class StepComponent<T extends Subsidy> extends FormComponent {
	@Input()
	step: number;
	@Input()
	subsidy: T;
	@Output()
	action: EventEmitter<SubsidyWizardAction<T>> = new EventEmitter();

	constructor(protected toastService: ToastService) {
		super();
	}

	onAction(action: StepContainerAction) {
		const data = this.getData(this.form.value);

		switch (action) {
			case StepContainerAction.NEXT:
				let nextStep = this.step;

				if (this.isFormValid()) {
					nextStep++;
				}

				this.action.emit({
					currentStep: this.step,
					data,
					goToStep: nextStep,
					showToast: false,
				});
				break;
			case StepContainerAction.PREV:
				this.action.emit({
					currentStep: this.step,
					data,
					goToStep: this.step - 1,
					showToast: false,
				});
				break;
			case StepContainerAction.SAVE:
				this.action.emit({
					currentStep: this.step,
					data,
					goToStep: this.step,
					showToast: true,
				});
				break;
			case StepContainerAction.DOSSIER_NEXT:
				if (this.step === 2 && this.isFormValid()) {
					this.action.emit({
						currentStep: 2,
						data,
						goToStep: (this.subsidy as any).requiredAttachments.length ? 5 : null,
						isDossier: true,
						showToast: false,
					});
				} else {
					this.action.emit({
						currentStep: 5,
						data: null,
						goToStep: null,
						isDossier: true,
						showToast: false,
					});
				}
				break;
		}
	}

	protected getData(formData: any): any {
		return formData;
	}

	protected onInvalidForm() {
		this.toastService.formError();
	}

	// TODO: Test if these work (toastService with inject) on the StepWithAttachmentsComponent
	protected resetInvalidForm() {
		this.toastService.clearToast();
	}
}
